import React from 'react';
import tecno from '../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function TemplateProyect(props) {
    
    

    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">{props.title}</h2>
                <div className='folder-porfolio'>

                    <iframe src={props.video} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

                    <div className="list" >
                        {tecno.filter(tec => tec.T === props.tecfilter[0] || tec.T === props.tecfilter[1] || tec.T === props.tecfilter[2] || tec.T === props.tecfilter[3] || tec.T === props.tecfilter[4] || tec.T === props.tecfilter[5] || tec.T === props.tecfilter[6] || tec.T === props.tecfilter[7] || tec.T === props.tecfilter[8] || tec.T === props.tecfilter[9] ).map(tec => (

                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>
                       {props.description}
                    </p>

                    <a href={props.github} target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>
                <div className='after'>
                    <Link to={props.after} className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>
            </section>
        </React.Fragment>
    );
}
export default TemplateProyect;